import { useState } from "react";
import { useCookies } from "react-cookie";
import * as Constants from "../../../constants/urls"

export default function AdminBarcode(){
    const [cookies, setCookie, removeCookie] = useCookies();
    const [data , setData]=useState([]);
    return(<>

    </>)
}